import { render, staticRenderFns } from "./TermsContent.vue?vue&type=template&id=0a0d7450"
import script from "./TermsContent.vue?vue&type=script&lang=js"
export * from "./TermsContent.vue?vue&type=script&lang=js"
import style0 from "./TermsContent.vue?vue&type=style&index=0&id=0a0d7450&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports